export default "__VITE_ASSET__gZEL9_Qi__"